import menu from './menu.js'
export default menu


// WEBPACK FOOTER //
// ./src/store/menu/index.js